import { render, staticRenderFns } from "./ques-judge.vue?vue&type=template&id=715b5be7&scoped=true"
import script from "./ques-judge.vue?vue&type=script&lang=js"
export * from "./ques-judge.vue?vue&type=script&lang=js"
import style0 from "./ques-judge.vue?vue&type=style&index=0&id=715b5be7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "715b5be7",
  null
  
)

export default component.exports